var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailRush(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m117.25 4.4805h-106.49c-4.2227 0-7.5508 3.457-7.5508 7.5508v60.672c0 4.2227 3.457 7.5508 7.5508 7.5508h106.37c4.2227 0 7.5508-3.457 7.5508-7.5508v-60.672c0.12891-4.2227-3.3281-7.5508-7.4258-7.5508zm-53.246 40.191-43.777-31.871h87.68zm-21.887-5.6328-30.594 27.648v-49.922zm6.9102 5.1211 10.496 7.6797c1.2812 1.0234 2.9453 1.4062 4.4805 1.4062s3.1992-0.51172 4.4805-1.4062l10.496-7.6797 30.848 27.777h-91.648zm36.863-5.1211 30.594-22.27v49.922z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.145 92.16c-2.3047 0-4.2227 1.9219-4.2227 4.2227v14.594c0 2.3047 1.9219 4.2227 4.2227 4.2227 2.3047 0 4.2227-1.9219 4.2227-4.2227v-14.594c-0.12891-2.3047-1.918-4.2227-4.2227-4.2227z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 92.16c-2.3047 0-4.2227 1.9219-4.2227 4.2227v23.039c0 2.3047 1.9219 4.2227 4.2227 4.2227 2.3047 0 4.2227-1.9219 4.2227-4.2227v-23.039c0-2.3047-1.918-4.2227-4.2227-4.2227z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.855 92.16c-2.3047 0-4.2227 1.9219-4.2227 4.2227v14.594c0 2.3047 1.9219 4.2227 4.2227 4.2227 2.3047 0 4.2227-1.9219 4.2227-4.2227v-14.594c0-2.3047-1.918-4.2227-4.2227-4.2227z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailRush);
export default __webpack_public_path__ + "static/media/emailRush.650f54241428562970c5a4758205f77b.svg";
export { ForwardRef as ReactComponent };